/**
 * utility for conditionally joining classNames together
 * @param  {Object} conditionalClass with property as css class and value as boolean
 * @return {String} return joining css classnames whose value is true in conditionalClass
 */
const classNames = (conditionalClass = {}) => {
  return Object.keys(conditionalClass)
    .filter(cssClass => conditionalClass[cssClass])
    .join(' ');
}

const checkPermissionOnElement = (permissionString) => {
  let aclPermissions = sessionStorage.user && JSON.parse(sessionStorage.user).aclPermissions;
  let scopeFound = false;
  if(aclPermissions) {
    let permissionsList = aclPermissions.acl_role && aclPermissions.acl_role.acl_permissions;
    if(permissionsList && permissionsList.length > 0) {
      permissionsList.forEach((ele) => {
        if(ele.name === permissionString) {
          scopeFound = true;
        }
      })
      return scopeFound;
    }
  } else return scopeFound;
}

/**
 * to check status-timeline package is used on CO or PUM
 */
const isLocationOnboarding = () => window.location.hostname.includes('onboarding');

export {
  classNames,
  isLocationOnboarding,
  checkPermissionOnElement
};